module.exports = __webpack_public_path__ + "img/Group2.e4876701.png";